import { render, staticRenderFns } from "./PublicPaymentResult.vue?vue&type=template&id=185c7e22&scoped=true"
import script from "./PublicPaymentResult.vue?vue&type=script&lang=js"
export * from "./PublicPaymentResult.vue?vue&type=script&lang=js"
import style0 from "./PublicPaymentResult.vue?vue&type=style&index=0&id=185c7e22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c7e22",
  null
  
)

export default component.exports